export default "__VITE_ASSET__CmPlG7gs__"